module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAATFJREFUKBW9kqGOwkAQhtmGtE8ASQUCheANLiCAoECQnLqzlzQVNIDGo0lq2jfA4RFgeQE0CnPncK1o7//naLNtegbBJtudzs63/8zs1mqvHoqCjuN8KqWmpmkufN//qUrCdd1pkiRfhmHMgyC4GQwilKbpRxRFJwQ0yyB879jfwz/D7HA/A5ewL5hdnHrU4Qe0A1iH2gZqR4KSKg0GE4LZxbwgaIi1D0CH1vDJyEH+leArSmhpSjnE2AKowWfYbQlQahuG4Yq2PqRG3QG7T6XMB8Wx53mN7D9bC6DeCMBbBEnD2O0ynIM6xO4xPcuyBv/BUiMg3uO+qhFUoiIOkG7jsDc8krso8kVUQayHL+lxNZJ2HMc9+gXExhxzhMsttJwBHPB/Uwl1T2zbPvx5n/z+AvyJocrqQJAjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-guanbi.png
// module id = +zKi
// module chunks = 1